import { render } from "./IconSwitchVertical02.vue?vue&type=template&id=2e6eb466"
const script = {}

import exportComponent from "/home/production/domains/architect.youniversity.be/public_html/architect/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__